<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Frontbmatterbheads">Flowers</p>
<p class="P_Chapterbintrobtext">Flowers are probably the most popular choice of all cake decorations. There are many books written on the art of sugar flower making. This taster from <em>The Contemporary Cake Decorating Bible</em> touches on this subject here. The simplest representation of a flower is a cut-out shape. Other more interesting ways of representing flowers are to create fabric-effect flowers out of paste or try your hand at creating lifelike flowers.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?78a28dc1